
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Webhook, Database, Mail } from "lucide-react";

const IntegracoesTabContent = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Webhook className="h-5 w-5 text-financeiro-accent-DEFAULT" />
            Webhooks
          </CardTitle>
          <CardDescription>
            Configure webhooks para integração com outros sistemas
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="grid w-full items-center gap-1.5">
              <Label htmlFor="webhook-url">URL do Webhook</Label>
              <Input 
                id="webhook-url" 
                placeholder="https://exemplo.com/webhook" 
              />
              <p className="text-xs text-muted-foreground">
                URL para onde serão enviadas as notificações de eventos
              </p>
            </div>
            <div className="grid w-full items-center gap-1.5">
              <Label htmlFor="webhook-key">Chave de Segurança</Label>
              <Input 
                id="webhook-key" 
                placeholder="Chave secreta" 
                type="password"
              />
            </div>
            <Button className="w-full">Salvar Configurações</Button>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Database className="h-5 w-5 text-financeiro-accent-DEFAULT" />
            API de Bancos
          </CardTitle>
          <CardDescription>
            Configure a integração com APIs bancárias
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="grid w-full items-center gap-1.5">
              <Label htmlFor="api-key">Chave da API</Label>
              <Input 
                id="api-key" 
                placeholder="Insira a chave da API" 
                type="password"
              />
            </div>
            <div className="grid w-full items-center gap-1.5">
              <Label htmlFor="api-endpoint">Endpoint Base</Label>
              <Input 
                id="api-endpoint" 
                placeholder="https://api.banco.com/v1" 
              />
            </div>
            <Button className="w-full">Salvar Configurações</Button>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Mail className="h-5 w-5 text-financeiro-accent-DEFAULT" />
            Configurações de E-mail
          </CardTitle>
          <CardDescription>
            Configure o envio de notificações por e-mail
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="grid w-full items-center gap-1.5">
              <Label htmlFor="email-host">Servidor SMTP</Label>
              <Input 
                id="email-host" 
                placeholder="smtp.exemplo.com" 
              />
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div className="grid w-full items-center gap-1.5">
                <Label htmlFor="email-user">Usuário</Label>
                <Input 
                  id="email-user" 
                  placeholder="user@exemplo.com" 
                />
              </div>
              <div className="grid w-full items-center gap-1.5">
                <Label htmlFor="email-password">Senha</Label>
                <Input 
                  id="email-password" 
                  placeholder="••••••••" 
                  type="password"
                />
              </div>
            </div>
            <Button className="w-full">Testar e Salvar</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default IntegracoesTabContent;
